import { first } from 'utils/array';

export function decodeParam(
  param: string | string[] | undefined,
): string | undefined {
  try {
    const s = first(param);
    return s ? decodeURI(s) : undefined;
  } catch (e) {
    return undefined;
  }
}

export function safeUrl(value: string, base?: string | URL): URL | undefined {
  try {
    return new URL(value, base);
  } catch {
    return undefined;
  }
}

export function parseInteger(
  value: string | string[] | undefined,
): number | undefined {
  try {
    const number = parseInt(decodeParam(value) ?? '', 10);
    return Number.isNaN(number) ? undefined : number;
  } catch (e) {
    return undefined;
  }
}

type Primitive = null | undefined | string | number | boolean;

export function buildQueryParam(
  data: Record<string, Primitive | readonly Primitive[]>,
  initialParams?: URLSearchParams,
): string {
  const params = initialParams || new URLSearchParams(initialParams);

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      params.delete(key);
    } else if (Array.isArray(value)) {
      params.delete(key);
      value.forEach((value) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString());
        }
      });
    } else {
      params.set(key, value.toString());
    }
  });

  params.sort();
  return params.toString();
}

export function getAllSearchParams(
  searchParams: URLSearchParams,
): Record<string, string | string[]> {
  const paramsObject: Record<string, string | string[]> = {};

  searchParams.forEach((value, key) => {
    if (paramsObject[key]) {
      if (Array.isArray(paramsObject[key])) {
        (paramsObject[key] as string[]).push(value);
      } else {
        paramsObject[key] = [paramsObject[key] as string, value];
      }
    } else {
      paramsObject[key] = value;
    }
  });

  return paramsObject;
}
